module.exports = __webpack_public_path__ + "static/media/profile-pic-1.7f80c9da.jpg";